/* To move */
import Facebook from './fb--share.svg';
import Twitter from './twitter--share.svg';
/* To move */

var ShareIcons = {
  Facebook: Facebook,
  Twitter: Twitter
};
export default ShareIcons;